<boi-validation-error-generic [validationErrors]="validationErrors" [propertyNames]="validationPropertyNames">
</boi-validation-error-generic>

<kendo-textbox-container>
    <div [ngClass]="cssClasses" class="field-container">
        <div class="field-label mandatory" *ngIf="labelName" [boiRequiredFormField]="required ? labelName : undefined">
            <label [innerHTML]="labelName|localizeLabel"></label>
        </div>

        <div class="field-input">
            <ng-content></ng-content>
            <button class="primary-button vo-secondary-button-1" [innerHtml]="browseButtonLabel | localizeLabel"
                (click)="fileInput.click()" [disabled]="isFieldDisabled"></button>
            <input class="d-none" kendoTextBox type="file" #fileInput (change)="onFileUploadChange($event.target.files)"
                [accept]="acceptFileTypes" [multiple]="allowMultipleUpload" />
        </div>
    </div>
</kendo-textbox-container>